<template>
    <header>
        <nav class="navbar navbar-expand-lg navbar-light bg-light d-lg-none" id="mobile-navbar">
            <div class="container">
                <button class="navbar-toggler" type="button" @click="toggleNavbar">
                    <span class="navbar-toggler-icon"></span>
                </button>
                <!-- <a class="navbar-brand" href="#">ΛKF</a> -->
            </div>
        </nav>
        <!-- 桌面端的默认导航 -->
        <nav class="navbar navbar-expand-lg navbar-light bg-light d-none d-lg-block"
            :class="{ 'opaque-navbar': isTransparent, 'grey-font': isNewsRoute }">
            <div class="container">
                <!-- <a class="navbar-brand" href="#">ΛKF</a> -->
                <a class="navbar-brand" href="#">
                    <img src="../assets/images/logo.png" alt="ΛKF Logo" class="ΛKF-logo">
                </a>
                <div class="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul class="navbar-nav ml-auto" style="white-space: nowrap; display: flex; flex-wrap: nowrap;">
                        <li class="nav-item">
                            <a class="nav-link" href="/">首页</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" href="#">关于ΛKF</a>
                            <!-- 悬浮框内容 -->
                            <div class="dropdown-content">
                                <div class="suspend">
                                    <div class="left">
                                        <h3>关于ΛKF</h3>
                                        <div>
                                            <ul class="suspend-ul">
                                                <li><a class="nav-link" href="#" @click.prevent="jump('BrandInfo')">品牌信息</a>
                                                </li>
                                                <li><a class="nav-link" href="#"
                                                        @click.prevent="jump('BrandCulture')">品牌文化</a></li>
                                                <li><a class="nav-link" href="#" @click.prevent="jump('NewsList')">品牌资讯</a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="right">
                                        <img src="../assets/images/logo.png" alt="关于ΛKF图片" class="brand-image">
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" href="#">明星单品</a>
                            <!-- 悬浮框内容 -->
                            <div class="dropdown-content">
                                <div class="suspend">
                                    <div class="left">
                                        <h3>明星单品</h3>
                                        <div>
                                            <ul class="suspend-ul">
                                                <li v-for="product in products" :key="product.id">
                                                    <a class="nav-link" href="#" @click.prevent="navigate(product.id)">{{
                                                        product.name }}</a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="mx_right">
                                        <img src="../assets/images/product/cn_small.png" alt="关于ΛKF图片" class="brand-image">
                                        <img src="../assets/images/product/yyp_small.png" alt="关于ΛKF图片" class="brand-image">
                                        <img src="../assets/images/product/jmg_small.png" alt="关于ΛKF图片" class="brand-image">
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" href="#">所有产品</a>
                            <!-- 在悬浮框内容的部分添加无序列表结构 -->
                            <div class="dropdown-content">
                                <div class="suspend">
                                    <div class="suspend-content">
                                        <div v-for="(category, index) in categories" :key="index"
                                            class="suspend-content-ul">
                                            <strong>{{ category.name }}</strong>
                                            <ul class="suspend-ul">
                                                <li v-for="(product, pIndex) in category.products" :key="pIndex">
                                                    <a href="#" @click.prevent="navigate(product.id)">{{ product.name
                                                    }}</a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" href="/AntiFake">防伪查询</a>
                        </li>
                        <li class="nav-item">
                            <router-link class="nav-link" to="/news">品牌资讯</router-link>
                        </li>
                        <!-- <li class="nav-item">
                            <a class="nav-link" href="#">会员之家</a>
                        </li> -->
                        <li class="nav-item">
                            <a class="nav-link" href="/Contract">联系我们</a>
                        </li>
                        <!-- <li class="nav-item">
                    <div class="national_flag" style="margin-left: auto;">
                        <a href="http://ΛKFcosmetic.co.kr" target="_blank" class="nav-icon" style="display: flex; align-items: center;">
                            <img src="../assets/images/Korean.png" alt="跳转图标" class="nav-icon-image" style="margin-right: 5px;">
                            <span>韩国官网</span>
                        </a>
                    </div>
                </li> -->
                    </ul>
                </div>
                <div class="national_flag" style="white-space: nowrap; display: flex; flex-wrap: nowrap;">
                    <a href="http://ΛKFcosmetic.co.kr" target="_blank" class="nav-icon">
                        <img src="../assets/images/Korean.png" alt="跳转图标" class="nav-icon-image"><span>韩国官网</span>
                    </a>
                </div>

            </div>
            <!-- <div class="national_flag">
                <a href="http://ΛKFcosmetic.co.kr" target="_blank" class="nav-icon">
                    <img src="../assets/images/Korean.png" alt="跳转图标" class="nav-icon-image"><span>韩国官网</span>
                </a>
            </div> -->
        </nav>
        <!-- <nav class="navbar navbar-expand-lg navbar-light bg-light d-lg-none">
            <div class="national_flag">
                <a href="http://ΛKFcosmetic.co.kr" target="_blank" class="nav-icon">
                    <img src="../assets/images/Korean.png" alt="跳转图标" class="nav-icon-image"><span>韩国官网</span>
                </a>
            </div>
        </nav> -->
        <!-- 移动端侧边栏导航 -->
        <div class="sidebar" :class="{ 'show': isNavbarOpen }">
            <ul class="navbar-nav">
                <li class="nav-item">
                    <a class="nav-link" href="/">首页</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#">关于ΛKF</a>
                    <img class="right-arrow" src="../assets/images/right.png" @click="openSubMenu('mobileAboutΛKF')"
                        alt="Right Arrow">
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#">明星单品</a>
                    <img class="right-arrow" src="../assets/images/right.png" @click="openSubMenu('mobileStarProducts')"
                        alt="Right Arrow">
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#">所有产品</a>
                    <img class="right-arrow" src="../assets/images/right.png" alt="Right Arrow"
                        @click="openSubMenu('mobileAllProducts')">
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="/AntiFake">防伪查询</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="/news">品牌资讯</a>
                </li>
                
                <li class="nav-item">
                    <a class="nav-link" href="/Contract">联系我们</a>
                </li>
            </ul>
        </div>

        <!-- 子菜单侧边栏 -->
        <div class="sub-sidebar" :class="{ 'show': isSubMenuOpen4 }">
            <div class="sub-sidebar-header" @click="closeSubMenu4">
                <img class="right-arrow" src="../assets/images/left.png" alt="Right Arrow" style="">
                <div>{{ subMenuTitle }}</div>
            </div>
            <ul class="navbar-nav">
                <li v-for="item in currentSubMenuItems" :key="item.name" class="nav-item">
                    <a class="nav-link" href="#" @click.prevent="navigate2(item.id)">{{ item.name }}</a>
                </li>
            </ul>
        </div>
        <!-- 子菜单侧边栏 -->
        <div class="sub-sidebar" :class="{ 'show': isSubMenuOpen }">
            <div class="sub-sidebar-header" @click="closeSubMenu">
                <img class="right-arrow" src="../assets/images/left.png" alt="Right Arrow" style="">
                <div>{{ subMenuTitle }}</div>
            </div>
            <ul class="navbar-nav">
                <li v-for="item in currentSubMenuItems" :key="item.name" class="nav-item">
                    <a class="nav-link" href="#" @click.prevent="navigate(item.id)">{{ item.name }}</a>
                </li>
            </ul>
        </div>

        <div class="sub-sidebar" :class="{ 'show': isSubMenuOpen2 }">
            <div class="sub-sidebar-header" @click="closeSubMenu2">
                <img class="right-arrow" src="../assets/images/left.png" alt="Right Arrow" style="">
                <div>{{ subMenuTitle }}</div>
            </div>
            <ul class="navbar-nav">
                <li v-for="item in mobileAllProducts" :key="item.name" class="nav-item">
                    <a class="nav-link" href="#">{{ item.name }}</a>
                    <img class="right-arrow" src="../assets/images/right.png" alt="Right Arrow"
                        @click="openSubMenu2(item.subMenu)">
                </li>
            </ul>
        </div>

        <div class="sub-sidebar" :class="{ 'show': isSubMenuOpen3 }">
            <div class="sub-sidebar-header" @click="closeSubMenu3">
                <img class="right-arrow" src="../assets/images/left.png" alt="Right Arrow" style="">
                <div>{{ subMenuTitle }}</div>
            </div>
            <ul class="navbar-nav">
                <li v-for="item in currentSubMenuItems" :key="item.name" class="nav-item">
                    <a class="nav-link" href="#" @click.prevent="navigate(item.id)">{{ item.name }}</a>
                </li>
            </ul>
        </div>

    </header>
</template>

<script>
export default {
    name: 'Header',
    data () {
        return {
            isTransparent: true, // 默认为透明状态
            isSubMenuOpen: false,
            isSubMenuOpen2: false,
            isSubMenuOpen3: false,
            isSubMenuOpen4: false,
            subMenuTitle: '',
            currentSubMenuItems: [],
            prevScrollPos: 0, // 用于存储上一次滚动的位置
            subMenuOpen: '', // 存储当前打开的子菜单
            isNavbarOpen: false,
            categories: [
                { name: '眼妆', products: [{ id: 2007, name: '睫毛膏' }, { id: 2008, name: '睫毛膏打底' }, { id: 1003, name: '眼线胶笔' }, { id: 2026, name: '眼线液笔' }, { id: 2009, name: '眼影' }, { id: 2010, name: '眉笔' }, { id: 8, name: '眉粉' }, { id: 9, name: '眼线膏' }] },
                { name: '唇妆', products: [{ id: 2001, name: '唇泥' }] },
                { name: '底妆', products: [{ id: 2006, name: '散粉' }, { id: 12, name: '隔离霜' }, { id: 3003, name: '粉底液' }, { id: 14, name: '定妆喷雾' }] },
                { name: '护肤', products: [{ id: 15, name: '化妆水' }, { id: 16, name: '乳液' }, { id: 17, name: '水乳套装' }] },
                { name: '工具', products: [{ id: 18, name: '化妆刷' }, { id: 19, name: '化妆棉片' }, { id: 5003, name: '双眼皮贴' }] },
                { name: '卸妆清洁', products: [{ id: 2021, name: '洗面奶' }, { id: 2022, name: '泥膜' }, { id: 2023, name: '卸妆水' }, { id: 2024, name: '卸妆油' }, { id: 2025, name: '卸妆湿巾' }] }
            ],
            products: [
                { id: 2001, name: 'ΛKF唇泥' },
                { id: 5003, name: 'ΛKF双眼皮贴' },
                { id: 1003, name: 'ΛKF眼线胶笔' },
                { id: 2009, name: 'ΛKF眼影盘' },
                { id: 3003, name: 'ΛKF粉底液' },
                { id: 2006, name: 'ΛKF散粉' },
                { id: 2007, name: 'ΛKF睫毛膏' }
            ],


            subMenus: {
                mobileAboutΛKF: [
                    { id: 'BrandInfo', name: '品牌信息' },
                    { id: 'BrandCulture', name: '品牌文化' },
                    { id: 'NewsList', name: '品牌资讯' }
                ],
                mobileStarProducts: [
                { id: 2001, name: 'ΛKF唇泥' },
                { id: 5003, name: 'ΛKF双眼皮贴' },
                { id: 1003, name: 'ΛKF眼线胶笔' },
                { id: 2009, name: 'ΛKF眼影盘' },
                { id: 3003, name: 'ΛKF粉底液' },
                { id: 2006, name: 'ΛKF散粉' },
                { id: 2007, name: 'ΛKF睫毛膏' }
                ],

                eyeMakeup: [
                    { id: 2007, name: '睫毛膏' },
                    { id: 2008, name: '睫毛膏打底' },
                    { id: 1003, name: '眼线胶笔' },
                    { id: 2026, name: '眼线液笔' },
                    { id: 2009, name: '眼影' },
                    { id: 2010, name: '眉笔' },
                    { id: 8, name: '眉粉' },
                    { id: 9, name: '眼线膏' }
                ],
                lipMakeup: [
                    { id: 2001, name: '唇泥' }
                ],
                foundation: [
                    { id: 2006, name: '散粉' },
                    { id: 12, name: '隔离霜' },
                    { id: 3003, name: '粉底液' },
                    { id: 14, name: '定妆喷雾' }
                ],
                skincare: [
                    { id: 15, name: '化妆水' },
                    { id: 16, name: '乳液' },
                    { id: 17, name: '水乳套装' }
                ],
                tools: [
                    { id: 18, name: '化妆刷' },
                    { id: 19, name: '化妆棉片' },
                    { id: 5003, name: '双眼皮贴' }
                ],
                cleansing: [
                    { id: 2021, name: '洗面奶' },
                    { id: 2022, name: '泥膜' },
                    { id: 2023, name: '卸妆水' },
                    { id: 2024, name: '卸妆油' },
                    { id: 2025, name: '卸妆湿巾' }
                ]
            },
            mobileAllProducts: [
                { id: 'EyeMakeup', name: '眼妆', subMenu: 'eyeMakeup' },
                { id: 'LipMakeup', name: '唇妆', subMenu: 'lipMakeup' },
                { id: 'Foundation', name: '底妆', subMenu: 'foundation' },
                { id: 'Skincare', name: '护肤', subMenu: 'skincare' },
                { id: 'Tools', name: '工具', subMenu: 'tools' },
                { id: 'Cleansing', name: '卸妆清洁', subMenu: 'cleansing' }
            ],
        };
    },
    mounted () {
        window.addEventListener('scroll', this.handleScroll);

        // this.checkRoute();
    },
    beforeDestroy () {
        window.removeEventListener('scroll', this.handleScroll);
    },
    computed: {
        currentRoute () {
            return this.$route.path;
        },
        isNewsRoute () {
            const prefixes = ['/news', '/brand-info', '/brand-culture', '/product', '/Contract', '/AntiFake', '/buy'];
            return prefixes.some(prefix => this.currentRoute.startsWith(prefix));
        }
    },
    methods: {
        navigate2 (productId) {
            this.$router.push({ name: productId, });
            location.reload();
        },
        navigate (productId) {
            this.$router.push({ name: 'BuyPage', params: { productId } });
            location.reload();
        },
        jump (routeName) {
            console.log(routeName)
            this.$router.push({ name: routeName })
                .then(() => {
                    window.location.reload();
                });
        },
        openSubMenu (menu) {
            this.subMenuTitle = menu === 'mobileAboutΛKF' ? '关于ΛKF' :
                menu === 'mobileStarProducts' ? '明星单品' : '';
            this.currentSubMenuItems = this.subMenus[menu] || [];
            if (menu === 'mobileAllProducts') {
                this.isSubMenuOpen2 = true;
            } else if(menu === 'mobileAboutΛKF'){
                this.isSubMenuOpen4 = true;
            }else{
                this.isSubMenuOpen = true;
            }
        },
        openSubMenu2 (menu) {
            console.log(menu)
            this.subMenuTitle = menu === 'eyeMakeup' ? '眼妆' :
                menu === 'lipMakeup' ? '唇妆' :
                    menu === 'foundation' ? '底妆' :
                        menu === 'skincare' ? '护肤' :
                            menu === 'tools' ? '工具' :
                                menu === 'cleansing' ? '卸妆清洁' : '';
            this.currentSubMenuItems = this.subMenus[menu] || [];
            this.isSubMenuOpen3 = true;
        },
        closeSubMenu () {
            this.isSubMenuOpen = false;
            this.currentSubMenuItems = [];
        },
        closeSubMenu2 () {
            this.isSubMenuOpen2 = false;
            this.currentSubMenuItems = [];
        },
        closeSubMenu3 () {
            this.isSubMenuOpen3 = false;
            this.currentSubMenuItems = [];
        },
        closeSubMenu4 () {
            this.isSubMenuOpen4 = false;
            this.currentSubMenuItems = [];
        },
        handleScroll () {
            if (window.scrollY > 0) {
                this.isTransparent = false;
            } else {
                this.isTransparent = true;
            }
        },
        toggleNavbar () {
            this.isNavbarOpen = !this.isNavbarOpen;
        },
        toggleSubMenu (menu) {
            this.subMenuOpen = this.subMenuOpen === menu ? '' : menu;
        },
        // checkRoute() {
        //     // 获取当前路由路径
        //     const currentRoute = this.$route.path;
        //     // 检查当前路由是否匹配/news或/news/{id}
        //     if (currentRoute.startsWith('/news')) {
        //         // 如果匹配，则设置导航栏字体颜色为灰色
        //         console.log(currentRoute);
        //         // 可以根据实际情况修改样式类名
        //         document.querySelector('.navbar-nav').classList.add('grey-font');
        //     } else {
        //         // 如果不匹配，则移除导航栏灰色字体样式
        //         document.querySelector('.navbar-nav').classList.remove('grey-font');
        //     }
        // }
    },

}
</script>

<style scoped>
/* 移动端 */
@media only screen and (max-width: 996px) {
    li {
        border-bottom: 1px solid #eee;
        display: flex;
        justify-content: space-between;
    }
}


.sub-menu-icon {
    cursor: pointer;
}

/* .dropdown-content {
    display: none;
}
.show .dropdown-content {
    display: block;
} */
/* 韩国国旗 */
.national_flag {
    display: flex;
    align-items: center;
    width: 100px;
    /* position: absolute;
    margin-left: 78vw; */
    /* float: right;
    margin-top: -47px; */
    margin-left: 60px;
}

.grey-font .nav-link {
    color: rgb(0, 0, 0) !important;
}

.grey-font .national_flag {
    color: rgb(0, 0, 0) !important;
}

.nav-icon-image {
    width: 24px;
    /* 调整图标宽度 */
    height: 24px;
    /* 调整图标高度 */
    transition: transform 0.3s;
}


.mx_right img {
    /* width: 300px;
    height: 280px; */
}



.opaque-navbar {
    background-color: rgba(255, 255, 255, 0) !important;
    /* 设置透明背景色 */
    transition: background-color 0.3s ease;
    /* 添加过渡效果 */
    color: white;
    /* 设置字体颜色为白色 */
    /* 其他样式设置 */
}

/* .opaque-navbar .dropdown-content {
    color: black;
    background-color: rgba(255, 255, 255, 0.8) !important;

} */

.container {
    margin-right: 0;
    /* 将导航项在水平方向上居中 */
}

h1 {
    color: #333;
    font-size: 2.5rem;
}

.navbar {
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 1000;
    /* 确保导航栏在其他内容上方 */
}

/* 修改主要内容的样式 */
p {
    font-size: 1.2rem;
}

/* 移动端侧边栏导航 */
.sidebar {
    position: fixed;
    top: 56px;
    /* 与导航栏的高度相等，具体高度可根据需要调整 */
    bottom: 0;
    left: -85vw;
    /* 初始时隐藏侧边栏 */
    width: 85vw;
    padding-top: 1rem;
    background-color: #fff;
    transition: left 0.3s ease;
    z-index: 999;

}

.sidebar.show {
    left: 0;
    padding-left: 1rem;
    padding-right: 1rem;
    box-shadow: 10px 0 15px rgba(0, 0, 0, 0.2);
    /* 设置右侧外阴影 */
}

.right-arrow {
    float: right;
    cursor: pointer;
}

.sub-sidebar {
    position: fixed;
    top: 0;
    left: 0;
    margin-top: 3.6rem;
    /* 初始时隐藏侧边栏 */
    width: 85vw;
    height: 100%;
    background-color: #fff;
    z-index: 1100;
    transform: translateX(-100%);
    transition: transform 0.3s ease;
}

.sub-sidebar.show {
    transform: translateX(0);
    padding-left: 1rem;
    padding-right: 1rem;
    /* left: 0;
    padding-left: 1rem;
    padding-right: 1rem;
    box-shadow: 10px 0 15px rgba(0, 0, 0, 0.2); 设置右侧外阴影 */
}

.sub-sidebar-header {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    /* padding: 1rem; */
    /* background-color: #f8f9fa; */
    border-bottom: 1px solid #e9ecef;
}

#mobile-navbar {
    position: fixed;
    /* 设置为固定定位 */
    top: 0;
    /* 始终在顶部显示 */
    width: 100vw;
    /* 宽度占满整个屏幕 */
    z-index: 1000;
    /* 确保在其他内容上方 */
    border-bottom: 1px solid #7a7a7a;
    background-image: url("../assets/images/mobile/banner.jpg");
    background-repeat: no-repeat;
    background-size: 100% 100%;
}


/* 桌面端导航 */
.navbar-nav {
    margin-left: auto;
}

.navbar-brand img {
    width: 30%;
}

/* 桌面端图片 */
.desktop-image {
    width: 2000px;
    /* 设置图片宽度为屏幕宽度的80% */
}

.offset-md-3 {
    margin-left: 0%;
}

.col-md-6 {
    width: 100%;
}

/* p.desktop-image-description {
} */
@media (min-width: 768px) {
    .desktop-image-description {
        font-size: 44px;
    }
}

.nav-item:hover .dropdown-content {
    display: block;
}

/* 悬浮框样式 */
.dropdown-content {
    color: black;
    display: none;
    position: absolute;
    padding: 60px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    left: 50%;
    /* 居中显示 */
    transform: translateX(-50%);
    width: 100%;
    max-width: 1300px;
    /* 悬浮框的最大宽度 */
    background-color: #fff;
    z-index: 999;
    background-color: rgba(255, 255, 255, 0.8);
    /* 设置透明度 */
}


.suspend-content {
    display: flex;
    width: 100%;
    justify-content: space-around;
}

.suspend-content li {
    font-weight: 500;

}

.suspend-content-ul {
    text-align: center;
}

strong {
    margin-left: 34px;
}

.suspend {
    display: flex;
    justify-content: space-around;
    align-items: center;
}

.suspend-ul {
    display: flex;
    flex-direction: column;
    line-height: 40px;
}


/* 图片样式 */
.brand-image {
    width: 200px;
    height: auto;
    margin-right: 20px;
}

/* 取消a标签的默认样式 */
a {
    color: inherit;
    /* 继承父元素的文本颜色 */
    text-decoration: none;
    /* 取消下划线 */
}

/* 悬停时设置颜色 */
a:hover {
    /* color: #ff0000; 设置悬停时的颜色 */
}

li {
    list-style-type: none;
}</style>